import { render, staticRenderFns } from "./generalTransportPlan.vue?vue&type=template&id=23fe06ee&scoped=true"
import script from "./generalTransportPlan.vue?vue&type=script&lang=js"
export * from "./generalTransportPlan.vue?vue&type=script&lang=js"
import style0 from "./generalTransportPlan.vue?vue&type=style&index=0&id=23fe06ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe06ee",
  null
  
)

export default component.exports